import { TextField, Typography } from '@scale/scaleui';
import pluralize from 'pluralize';
import MultiSelect from 'corp/components/UI/Select';
import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';
import useOptInNotificationCard from './useOptInNotificationCard';
import { AssignmentEntry } from '@scale/shared/defaults';
import { twMerge } from 'tailwind-merge';

const AssignmentRow = ({
  assignment,
  setAssignment,
}: {
  assignment: AssignmentEntry;
  setAssignment: (assignment: AssignmentEntry) => void;
}) => {
  const handleChange = (field: keyof AssignmentEntry, value: any) => {
    setAssignment({ ...assignment, [field]: value });
  };

  return (
    <div className={twMerge('flex flex-col gap-4 rounded-lg w-full')}>
      <div className="flex gap-4">
        <div className="flex flex-col">
          <Typography.Paragraph2>Project ID*</Typography.Paragraph2>
          <TextField
            className="w-80"
            placeholder="Input the project ID..."
            value={assignment.projectId}
            onChange={e => handleChange('projectId', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

const OptInNotificationCardComponent: CompassCardComponent = ({
  index,
}: CompassCardComponentProps) => {
  const {
    columnIdWithWorkerIds,
    setColumnIdWithWorkerIds,
    assignment,
    setAssignment,
    numWorkers,
    columns,
  } = useOptInNotificationCard(index);

  return (
    <div className="flex flex-col gap-4">
      <Typography.Subtitle2>
        Send Opt-in Notifications to eligible workers to choose the project.
      </Typography.Subtitle2>
      <Typography.Paragraph2>
        Note that contributors can only be sent this notification once every three days, and this
        card cannot be used again in the same workflow. Please start a new workflow to run
        additional opt-in notifications.
      </Typography.Paragraph2>
      <div className="flex flex-col gap-2 w-full">
        <div>
          {numWorkers > 0 && (
            <Typography.Paragraph2>
              {`Selected column has ${numWorkers >= 1000 ? '1000+' : numWorkers} ${pluralize(
                'worker',
                numWorkers,
              )} which will receive opt-in notifications.`}
            </Typography.Paragraph2>
          )}
          <MultiSelect
            className="w-60 rounded-lg"
            multi={false}
            options={(columns ?? []).map((column: { id?: string; header?: string }) => {
              return {
                value: column.id ?? '-',
                label: column.header ?? '-',
              };
            })}
            disabled={false}
            placeholder="Select a column with worker ids"
            isSearchable={true}
            isClearable={true}
            value={columnIdWithWorkerIds}
            onChange={(e: any) => {
              setColumnIdWithWorkerIds(e === null ? null : e.value);
            }}
          />
        </div>
        {assignment && <AssignmentRow assignment={assignment} setAssignment={setAssignment} />}
      </div>
    </div>
  );
};

export default OptInNotificationCardComponent;
